import { Component, OnInit, ViewChild, AfterViewInit, ChangeDetectorRef, HostListener } from '@angular/core';
import { DashboardService } from '../../services/dashboard/dashboard.service';

import * as CustomizedPrinter from '../utils/customized-printer';
import { InboxService } from '../../services/inbox.service';
import { InboxViewComponent } from '../../inbox/inboxView/inboxView.component';
import { QmaConstant } from '../../constant/qma-constant';
import { FadingDialogComponent } from '../../dashboard/fading-dialog/fading-dialog.component';
import $ from 'jquery';
import '../../../../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js';
import { DashboardLocalService } from '../../services/dashboard/dashboard-local.service';
import { MyViewsService } from '../../services/myViews/my-views.service';
import { UserDataService } from '../../services/user-data.service';
import { PiwikProUtils } from '../../common/utility/piwikProUtils';

import * as HighCharts from 'highcharts';
import { Subscription } from 'rxjs';


import Exporting from 'highcharts/modules/exporting';
import OfflineExporting from 'highcharts/modules/offline-exporting';
import ExportData from 'highcharts/modules/export-data';
import CustomEvents from 'highcharts-custom-events';
import Annotations from 'highcharts/modules/annotations';

function applyHighchartsModule(module, Highcharts) {
  if (typeof module === 'function') {
    module(Highcharts);
  } else if (module && typeof module.default === 'function') {
    module.default(Highcharts);
  }
}

applyHighchartsModule(Exporting, HighCharts);
applyHighchartsModule(OfflineExporting, HighCharts);
applyHighchartsModule(ExportData, HighCharts);
applyHighchartsModule(CustomEvents, HighCharts);
applyHighchartsModule(Annotations, HighCharts);

@Component({
  selector: 'app-mailbox-statistics',
  templateUrl: './mailbox-statistics.component.html',
  styleUrls: ['./mailbox-statistics.component.scss']
})
export class MailboxStatisticsComponent implements OnInit, AfterViewInit {
  ngAfterViewInit(): void {
    /* this.cdr.detach(); */
  }
  dataToCloseInbox: { index?: number; name?: string; color?: string; count?: number } = {};
  rootNode: any;
  isMobile: boolean = false;
  HighCharts = HighCharts; // required
  hasLoaded = false;
  protected isRedrawInProgress = false;
  protected mailboxStatistics: any = {
    chart: {
      backgroundColor: '#FCFCFC',
      events: {
        load(e) {
          if (this.hasLoaded) return; // Prevent re-execution
          this.hasLoaded = true;
          if (this.options && this.options?.ngComponent) {
            this.options.ngComponent.redrawWidgets(this);
          }
        },
        redraw(e) {
          if (this.isRedrawInProgress) return;
          this.isRedrawInProgress = true;
          if (this.options && this.options?.ngComponent) {
            this.options.ngComponent.redrawWidgets(this);
          }
        }
      }
    },
    isRedrawInProgress: false,

    annotations: [],
    title: {
      useHTML: true,
      text: '<span style="line-height: 21.79px;font-size: 16px;font-family: \'OpenSansBold\';color:\'#272727\'">Mailbox Statistics</span>',
      align: 'left'
    },
    subtitle: {
      useHTML: true,
      text: '<span style="font-size:14px; color:"#5E5F70";font-family: \'OpenSans\'">* % As Of Yesterday  |  Click status graph to view recent inquiries </span>',
      align: 'center',
      verticalAlign: 'bottom',

    },
    labels: {
      items: []
    },
    legend: {
      enabled: false
    },
    plotOptions: {
      pie: {
        states: {
          inactive: {
            opacity: 1
          },
          hover: {
            brightness: 0
          }
        },
        size: 156,
        innerSize: '73%'
      }
    },
    tooltip: {
      backgroundColor: 'rgba(252,252, 252,1)',
      formatter(tooltip) {
        const t = tooltip.defaultFormatter.call(this, tooltip);
        const component = this.point.series.chart.options.ngComponent;
        // Mailbox stats changes for Resolved and Sent box
        // dont update tooltip for resolved and sent
        if (this.point.series && this.point.series.name && QmaConstant.MAILBOX_STATS_EXCLUDE_TOOLTIP_CHARTS.includes(this.point.series.name.toUpperCase())) {
          return false;
        }
        if (component) {
          const result = component.updateTooltip(tooltip, this.point, t);
          if (result) {
            return result;
          }
        }
        return t;
      },
      useHTML: true,
      shared: false,
      padding: 2,
      style: {
        zIndex: 1000
      }
    },
    series: [],
    navigation: {
      enabled: false,
      buttonOptions: {
        enabled: true,
        symbolSize: 28,
        symbolX: 25,
        symbolY: 22
      },
    },
    exporting: {
      enabled: true,
      // support larger print max width
      printMaxWidth: 3000,
      chartOptions: {
        chart: {
          width: 1500,
          height: 500
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true
            }
          }
        }
      },
      menuItemDefinitions: {
        maximize: {
          onclick() {
            if (this.options && this.options.ngComponent) {
              this.options.ngComponent.enterFullScreen(this);
            } else {
              console.log('mailbox-statistics: Failed to enter full screen');
            }
          },
          text: 'Maximize'
        },
        downloadCsv: {
          onclick() {
            if (this.options && this.options.ngComponent) {
              this.options.ngComponent.downloadCustomCsv();
            } else {
              console.log('mailbox-statistics: Failed to download CSV');
            }
          },
          text: 'Download CSV'
        }
      },
      buttons: {
        contextButton: {
          menuItems: [{
            textKey: 'printChart',
            onclick() {
              this.print();
            }
          }, {
            textKey: 'downloadPNG',
            onclick: () => { this.localService.download("mailbox-statistics", "png"); }
          }, {
            textKey: 'downloadJPEG',
            onclick: () => { this.localService.download("mailbox-statistics", "jpg"); }
          }, {
            textKey: 'downloadPDF',
            onclick: () => { this.localService.download("mailbox-statistics", "pdf"); }
          }, "downloadCsv", "maximize"], // "viewFullscreen"],
          symbol: 'url(assets/dashboard/context-menu.png)'
        }
      },
      csv: {
        decimalPoint: ":"
      }
    },
    credits: {
      enabled: false
    },
    ngComponent: null
  };
  protected barColors = { red: '#EF7B87', amber: '#FFBF00', green: '#00B0B9', darkgreen: '#00521D' };
  protected pieCenterIncrementX = 260;
  protected pieInitialPos = { x: 80, y: 60 };
  protected annotationInitialPos = { x: this.pieInitialPos.x + 20, y: this.pieInitialPos.y + 20 };
  protected annotationRadius = this.mailboxStatistics.plotOptions.pie.size / 2 - 11;
  protected categoryInitialPos = { x: this.pieInitialPos.x, y: this.pieInitialPos.y - this.annotationRadius - 12 };
  protected countInitialPos = { x: this.pieInitialPos.x - 5, y: this.pieInitialPos.y + 5 };
  protected trendInitialPos = { x: this.pieInitialPos.x - 15, y: this.pieInitialPos.y + 20 };
  protected pieColors = ['#0BA1F6', '#15AB9B', '#F17474', '#5C58C5'];
  protected trendColors = { up: '#3EAD16', down: '#CF1010' };
  protected labelColor = '#101010';
  protected defaultColor = '#dddddd';
  protected closeCallbackSet = false;
  protected closeCallbackEnabled = false;
  protected selectedIndex: number = 0
  mailboxStats: Array<any> = [];

  protected mailboxStatisticsChart: any;
  protected chartData: any;
  protected chartWidth: number;
  protected chartHeight: number;
  public showInboxView = false;
  @ViewChild(InboxViewComponent) inboxViewComponent;
  protected inboxViewIndex = -1;
  protected drilldownLabels = {};
  // server-side pagination requires caching of age data to support scrolling in inline view
  protected ageDataByName = {};
  protected fullScreen = false;
  @ViewChild(FadingDialogComponent, { static: true }) fadingDialogComponent;
  protected selectedGroup = "";
  public data: any;
  protected viewTypeSeparator = ' - ';
  // cached myview request and options
  protected myViewRequestObject: any;
  protected myViewRequestOptions: any;

  //Alignment of mailbox stats charts- double click on any group to see in tab then come back to dashboard
  protected isPreviousScreenSize = false;
  protected screenSize = 0;
  private subscription: Subscription;


  constructor(private dashboardService: DashboardService, private inboxService: InboxService,
    private localService: DashboardLocalService, private userDataService: UserDataService, private myViewService: MyViewsService, private cdr: ChangeDetectorRef) { // C153176-5011: myview handling
    this.mailboxStatistics.ngComponent = this;
    this.isMobile = (window.innerWidth <= QmaConstant.MOBILE_WIDTH);
    // handling myview inline view request
    this.initMyViewHandler();
  }

  ngOnInit() {
    try {
      this.subscription = this.dashboardService.getmailBoxStatsSubject.subscribe(data => {
        if (data) {
        this.data = data;
        if (!this.checkEmptyObject(data) && this.handleMailboxStatistics(data)) {
          CustomizedPrinter(HighCharts);
          const component = this;
          this.mailboxStats = this.data.mailBoxStat;
          setTimeout(() => {
            const elem = $('#mailbox-statistics');
            if (elem && elem.length) {
              HighCharts.setOptions({ lang: { thousandsSep: "," } });
              component.mailboxStatisticsChart = HighCharts.chart('mailbox-statistics', component.mailboxStatistics);
              component.mailboxStatisticsChart.options.ngComponent = component;
              component.populateDrilldownLabels(component.mailboxStatisticsChart);
              component.setupEventHandler();

            }
          }, 500);
        }
        }
      });
      this.inboxService.ageDataEvent.subscribe((ageData: any) => {
        this.handleAgeData(ageData);
      });

      /* To enable mailbox stats for specific group selection*/
      this.localService.getSelectedGroupName.subscribe(groupName => {
        let selectedGroup = "All";
        if (groupName !== "") {
          selectedGroup = groupName;
        }
        if (this.selectedGroup === selectedGroup) {
          // the group data was just requested, skip requesting again.
          return;
        }
        this.selectedGroup = selectedGroup;
        this.dashboardService.getmailBoxStats(this.selectedGroup);
      });
    } catch (e) {
      console.log(e);
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  checkEmptyObject(obj: any) {
    return Object.entries(obj).length === 0 && obj.constructor === Object;
  }
  getSpaceBasedonLength(){
    let chartLength = this.chartData.length;
    if(chartLength === 1){
      return 2;
    }
    else if(chartLength === 2){
      return 3;
    }
    else if(chartLength === 3){
      return 4;
    }
    return  5;
  }
  redrawWidgets(chart) {
    if (!chart) return;

    if (chart.chartWidth === this.chartWidth && chart.chartHeight === this.chartHeight) {
      return; // Skip unnecessary updates
    }

    this.chartWidth = chart.chartWidth;
    this.chartHeight = chart.chartHeight;

    if (this.isMobile) {
      this.pieCenterIncrementX = this.chartWidth / 2;
    }
    else {
      this.pieCenterIncrementX = Math.max(160, Math.floor(this.chartWidth / this.getSpaceBasedonLength()));
    }

    this.pieInitialPos = { x: this.pieCenterIncrementX - 30, y: 100 };
    this.categoryInitialPos = { x: this.pieInitialPos.x, y: this.categoryInitialPos.y };
    this.countInitialPos = { x: this.pieInitialPos.x - 5, y: this.countInitialPos.y };
    this.trendInitialPos = { x: this.pieInitialPos.x - 15, y: this.trendInitialPos.y };
    this.annotationInitialPos = { x: this.pieInitialPos.x + 20, y: this.pieInitialPos.y + 60 };

    const component = this;

     setTimeout(() => {
      component.updateChartData();

      if (this.mailboxStatisticsChart) {
        try {
          if (this.mailboxStatisticsChart.renderTo && this.mailboxStatisticsChart.container) {
            this.mailboxStatisticsChart.destroy();
          }
        } catch (e) {
          console.warn('Error while destroying chart', e);
        }
      }

      component.mailboxStatisticsChart = HighCharts.chart('mailbox-statistics', component.mailboxStatistics);
      component.mailboxStatisticsChart.options.ngComponent = component;
      component.populateDrilldownLabels(component.mailboxStatisticsChart);
      component.setupEventHandler();
     }, 0);
  }

  redrawWidgetsAfterDataChange(chart) {
    //Alignment of mailbox stats charts- double click on any group to see in tab then come back to dashboard
    if (chart?.chartWidth) {
      if (!this.isPreviousScreenSize) {
        this.screenSize = chart.chartWidth;
        this.isPreviousScreenSize = true;
      }
      this.chartWidth = chart.chartWidth == this.screenSize ? chart.chartWidth : this.screenSize;

      this.chartHeight = chart.chartHeight;
      if (this.isMobile) {
        this.pieCenterIncrementX = this.chartWidth / 2;
      }
      else {
        this.pieCenterIncrementX = Math.max(160, Math.floor(this.chartWidth / this.getSpaceBasedonLength()));
      }
      this.pieInitialPos = { x: this.pieCenterIncrementX - 30, y: 100 };
      this.categoryInitialPos = { x: this.pieInitialPos.x, y: this.categoryInitialPos.y };
      this.countInitialPos = { x: this.pieInitialPos.x - 5, y: this.countInitialPos.y };
      this.trendInitialPos = { x: this.pieInitialPos.x - 15, y: this.trendInitialPos.y };
      this.annotationInitialPos = { x: this.pieInitialPos.x + 20, y: 160 };
      const component = this;
      setTimeout(() => {
        component.updateChartData();
        if (this.mailboxStatisticsChart && typeof this.mailboxStatisticsChart.destroy === 'function') {
          try {
            // Check if chart is still valid
            if (this.mailboxStatisticsChart.renderTo && this.mailboxStatisticsChart.container) {
              this.mailboxStatisticsChart.destroy();
            } else {
              // If chart is invalid, just set it to null without destroying
              this.mailboxStatisticsChart = null;
            }
          } catch (e) {
            console.warn('Error while destroying request type chart', e);
            // Ensure requestTypeChart is nullified even if destroy fails
            this.mailboxStatisticsChart = null;
          }
        }
        component.mailboxStatisticsChart = HighCharts.chart('mailbox-statistics', component.mailboxStatistics);
        component.mailboxStatisticsChart.options.ngComponent = component;
        component.populateDrilldownLabels(component.mailboxStatisticsChart);
        component.setupEventHandler();
       }, 0);
    }

  }


  handleAgeData(ageData) {
    if (!ageData || !this.chartData || this.inboxViewIndex < 0) {
      return;
    }
    let category = this.chartData[this.inboxViewIndex].category;
    // cache/update age data per category
    ageData = Object.assign({}, ageData);
    if (!this.ageDataByName[category]) {
      this.ageDataByName[category] = ageData;
    } else {
      let cachedAgeData = this.ageDataByName[category];
      Object.keys(ageData).forEach(key => {
        if (key && ageData[key]) {
          if (cachedAgeData[key]) {
            cachedAgeData[key] += ageData[key];
          } else {
            cachedAgeData[key] = ageData[key];
          }
        }
      });
      ageData = cachedAgeData;
    }
  }

  buildDrilldownLabels(s, i, chart, category) {
    const name = category;
    //destroy prev SVGElement if any
    if (this.drilldownLabels[name]) {
      let prev_g = this.drilldownLabels[name];
      if (prev_g) {
        prev_g.hide();
        prev_g.destroy();
        delete this.drilldownLabels[name];
        // DO NOT delete age data here
      }
    }
    let g = chart.renderer.g().add();
    const preText = '<span id="mailbox-statistics-drilldown-label-pre" '
      + 'style="line-height: 15px;font-size: 15px;font-family: \'OpenSansLight\';color=\'#dddddd\';">'
      + 'LATEST INQUIRIES FROM ' + name.toUpperCase() + '</span>';
    const xStart = this.chartWidth * 0.03;
    const yStart = this.chartHeight * 0.92;
    const pre = chart.renderer.text(preText, xStart, yStart, true).add(g);
    let title = category + ' - Age +30 Days: ' + (s['30+'] ? s['30+'].toLocaleString() : 0);
    const g1vtext = '<span id="mailbox-statistics-drilldown-label-g1-' + i
      + '" style="line-height: 17px; font-size: 22px;" title="' + title + '">'
      + (s['30+'] ? s['30+'].toLocaleString() : 0) + '</span>';
    let bbox = pre.getBBox();
    if (bbox.width < 30) {
      bbox.width = 30;
    }
    const g1 = chart.renderer.text(g1vtext, xStart + bbox.width + 20, yStart, true).css({
      fontFamily: 'OpenSansLight',
      color: this.barColors.red,
      fontSize: 22,
      fontWeight: 600,
    }).attr({
      dataToggle: "true",
      zIndex: 100,
      opacity: 0.8,
      title: category + ' (Age +30 Days): ' + s['30+']
    }).add(g);
    title = category + ' - Age +15 Days: ' + (s['15+'] ? s['15+'].toLocaleString() : 0);
    const g2vtext = '<span id="mailbox-statistics-drilldown-label-g2-' + i
      + '" style="line-height:17px;font-size: 22px;" title="' + title + '">'
      + (s['15+'] ? s['15+'].toLocaleString() : 0) + '</span>';
    bbox = g1.getBBox();
    if (bbox.width < 30) {
      bbox.width = 30;
    }
    const g2 = chart.renderer.text(g2vtext, bbox.x + bbox.width + 10, yStart, true).css({
      fontFamily: 'OpenSansLight',
      color: this.barColors.amber,
      fontSize: 22,
      fontWeight: 600,
    }).attr({
      dataToggle: "true",
      zIndex: 100,
      opacity: 0.8,
      title: category + ' (Age 15 Days): ' + s['15+']
    }).add(g);
    title = category + ' - Age +05 Days: ' + (s['05+'] ? s['05+'].toLocaleString() : 0);
    const g3vtext = '<span id="mailbox-statistics-drilldown-label-g3-' + i
      + '" style="line-height:17px;font-size: 22px;" title="' + title + '">'
      + (s['05+'] ? s['05+'].toLocaleString() : 0) + '</span>';
    bbox = g2.getBBox();
    if (bbox.width < 30) {
      bbox.width = 30;
    }
    const g3 = chart.renderer.text(g3vtext, bbox.x + bbox.width + 10, yStart, true).css({
      fontFamily: 'OpenSansLight',
      color: this.barColors.green,
      fontSize: 22,
      fontWeight: 600,
    }).attr({
      title: category + ' (Age +5 Days): ' + s['05+'],
      dataToggle: "true",
      zIndex: 100,
      opacity: 0.8
    }).add(g);
    title = category + ' - Age <=05 Days: ' + (s['lt5'] ? s['lt5'].toLocaleString() : 0);
    const g4vtext = '<span id="mailbox-statistics-drilldown-label-g4-' + i
      + '" style="line-height:17px;font-size: 22px;" title="' + title + '">'
      + (s['lt5'] ? s['lt5'].toLocaleString() : 0) + '</span>';
    bbox = g3.getBBox();
    if (bbox.width < 30) {
      bbox.width = 30;
    }
    chart.renderer.text(g4vtext, bbox.x + bbox.width + 10, yStart, true).css({
      fontFamily: 'OpenSansLight',
      color: this.barColors.darkgreen,
      fontSize: 22,
      fontWeight: 600,
    }).attr({
      dataToggle: "true",
      zIndex: 100,
      opacity: 0.8
    }).add(g);
    if (this.showInboxView && i === this.inboxViewIndex) {
      g = g.show();
    } else {
      g = g.hide();
    }
    this.drilldownLabels[name] = g;
    setTimeout(() => {
      let elems = $('[dataToggle="true"]');
      // @ts-ignore 
      elems.tooltip({
        html: true,
        placement: "auto-right"
      });
    }, 0);
  }

  populateDrilldownLabels(chart) {
    if (!chart || !chart.series || !chart.series.length || !this.chartData) {
      return;
    }
  }

  setupEventHandler() {
    if (this.mailboxStatisticsChart) {
      // click handlers for read/unread slices
      this.mailboxStatisticsChart.series.forEach((series) => {
        if (series && series.points) {
          series.points.forEach((p) => {
            if (p && p.graphic) {
              const point = p;
              // modify pointer style
              if (point.graphic.element) {
                point.graphic.element.style.cursor = 'pointer';
              }
              // handle click on read/unread slices
              p.graphic.on('click', () => {
                if (point && point.series && point.series.chart && point.series.chart.options
                  && point.series.chart.options.ngComponent) {
                  const component = point.series.chart.options.ngComponent;
                  let name = point.name;
                  let color = point.color;
                  // Get the total count for the category, not just the slice count
                  const totalCount = component.chartData?.[point.series.index]?.count ?? point.y;
                  if (!name || name === 'other') {
                    name = component.chartData[point.series.index].category;
                    color = component.pieColors[point.series.index];
                  }
                  component.handleDoubleClick(point.series.index, name, color, totalCount);
                }
              });
            }
          });
        }
      });

      // Set up click handler for center count (total inquiries)
      this.chartData.forEach((chartItem, index) => {
        const selector = `.mailbox-stats-custom-label-${index} .mailbox-center-click-area`;

        // Use event delegation on the chart's container
        $('#mailbox-statistics').off('click', selector).on('click', selector, () => {
          if (chartItem.count > 0) {
            // handleDoubleClick will set preventAutoSelect based on the name
            // For center count, name will be just the category (no separator), so it will be treated as total
            this.handleDoubleClick(index, chartItem.category, this.pieColors[index], chartItem.count);
          }
        });
      });
    }
  }

  handleMailboxStatistics(data): boolean {
    if (!data || !data.mailBoxStat || !data.mailBoxStat.length) {
      console.log("No mail statistics from service returned!");
      return false;
    }
    const mailstats = data.mailBoxStat;
    if (!mailstats || !mailstats.length) {
      console.log("No mail statistics at all!");
      return false;
    }
    if(Array.isArray(this.chartData) && this.chartData.length !== 0){
      this.chartData = mailstats.map(e => {
        if (e && e.category && e.category.toUpperCase() === 'OUTBOX') {
          e.category = 'Sent';
        }
        return e;
      });
      this.redrawWidgetsAfterDataChange(this.mailboxStatisticsChart); //to change the chart size if there were changes in no of donut charts
    }
    else{
      this.chartData = mailstats.map(e => {
        if (e && e.category && e.category.toUpperCase() === 'OUTBOX') {
          e.category = 'Sent';
        }
        return e;
      });
    }

    // maximum four donuts allowed in mailbox statistics
    if (this.chartData && this.chartData.length > 4) {
      this.chartData.splice(4, this.chartData.length - 4);
    }
    return this.updateChartData();
  }

  updateChartData() {
    if (!this.chartData) {
      return false;
    }
    let chartData: Array<any> = this.chartData;
    this.mailboxStatistics.labels.items = [];
    this.mailboxStatistics.series = [];
    this.mailboxStatistics.annotations = [];


    if (this.isMobile) {
      chartData = [];
      chartData[0] = this.chartData[this.selectedIndex];
    }

    chartData.forEach((e, i) => {
      // set annotations
      if (e.count === undefined) {
        e.count = 0;
      }
      if (e.unReadCount === undefined) {
        e.unReadCount = 0;
      }
      if (e.percentWrtPrevDay === undefined) {
        e.percentWrtPrevDay = 0;
      }
      if (e.upOrDown === undefined) {
        e.upOrDown = 'down';
      }
      // prepare up/down label
      let label = '' + this.getPercentage(e.percentWrtPrevDay);
      let color = 'black';
      if (e.upOrDown && e.upOrDown === 'up') {
        if (label !== '0') {
          label = '&uarr;&nbsp;+' + label + '%';
        } else {
          label = '&uarr;&nbsp;' + label + '%';
        }
        color = this.trendColors.up;
      } else {
        if (label !== '0') {
          label = '&darr;&nbsp;-' + label + '%';
        } else {
          label = '&darr;&nbsp;' + label + '%';
        }
        color = this.trendColors.down;
      }

      // set chart series and up/down label
      this.mailboxStatistics.series.push({
        type: 'pie',
        name: e.category,
        data: [
          {
            name: e.category + this.viewTypeSeparator + 'read',
            y: parseInt(e.count, 10) > 0 ? parseInt(e.count, 10) - this.getUnReadCount(e) : 1,
            trend: label,
            color: this.getDonutColor(e.category)
          },
          {
            name: e.category + this.viewTypeSeparator + 'unread',
            y: this.getUnReadCount(e),
            color: this.pieColors[i]
          }
        ],
        center: [this.pieInitialPos.x + (i * this.pieCenterIncrementX), this.pieInitialPos.y + 50],
        showInLegend: false,
        emptyData: parseInt(e.count, 10) === 0,

        // Custom data labels to include category, trend, and count information
        dataLabels: {
          enabled: true,
          useHTML: true,
          className: `mailbox-stats-custom-label mailbox-stats-custom-label-${i}`,
          formatter: function() {
            if (!this.point.name.includes('unread')) {
              return `
                <div class="mailbox-stats-label-wrapper-new">
                  <!-- Category label -->
                  <div class="mailbox-stats-category-label">${e.category}</div>
                  <div class="mailbox-stats-divider"></div>
                  <!-- Trend indicator -->
                  <div class="mailbox-stats-trend-label" style="color: ${color};">${label}</div>
                  <div class="mailbox-stats-trend-spacer"></div>
                  <!-- Open Inquiries text -->
                  <!-- Count value -->
                  <div class="mailbox-stats-open-inquiries-label">Open Inquiries</div>
                  <div class="mailbox-center-click-area mailbox-stats-count-label">${(e.count !== undefined && e.count !== null ? e.count.toLocaleString() : 0)}</div>
                </div>
              `;
            } else {
              return null; // No label for the unread slice
            }
          },
          distance: '-99%',
          y: -150,
          color: this.labelColor,
          style: {
            pointerEvents: 'none'  // click through the label to ensure click register on chart
          }
        },

        // Keep your click event handler
        point: {
          events: {
            click: (evt) => {
              // Handle click events if needed

            }
          }
        }
      });
      if (this.showInboxView && i === this.inboxViewIndex) {
        setTimeout(() => {
          const elem = $(".mailbox-statistics-count-label-" + i);
          if (elem && elem.length) {
            elem.click(event => {
              if (this.closeCallbackEnabled) {
                this.closeInplaceView(event, i);
              }
            });
          }
        }, 2000);
      }
    });
    return true;
  }
  replaceHTMLEntities(str) {
    return str.replace(/&[^;]+;/g, '-');
  }

  countLabelBias(count: number): number {
    const label = '' + (count ? count.toLocaleString() : 0);
    if (!label || !label.length) {
      return 0;
    }
    return 15 + (2 - label.length) * 8;
  }

  handleDoubleClick(index, name: string, color, count) {
    this.dataToCloseInbox.index=index;
    this.dataToCloseInbox.name=name;
    this.dataToCloseInbox.color=color;
    this.dataToCloseInbox.count=count;
    if (this.fullScreen) {
      console.log("Skipping double click handling in full screen mode");
      return;
    }

    // Set preventAutoSelect flag to prevent auto-selection of first inquiry
    // Prevent auto-select for:
    // 1. Unread slice clicks (name contains 'unread')
    // 2. Center count clicks (name doesn't contain separator, meaning it's the total)
    // Allow auto-select only for read slice clicks (name contains separator + 'read' but not 'unread')
    const hasSeparator = name.includes(this.viewTypeSeparator);
    const isUnread = name.includes('unread');
    const isTotal = !hasSeparator; // Total count doesn't have the separator
    
    // Only allow auto-select for read slice, prevent for unread and total
    this.inboxService.preventAutoSelect = isUnread || isTotal;

    if (this.inboxViewIndex === -1 || this.inboxViewIndex === index) {
      // toggle the 'showInboxView'
      this.showInboxView = !this.showInboxView;
      this.dashboardService.setDashboardInline(this.showInboxView);
    } else {
      this.showInboxView = true;
      this.dashboardService.setDashboardInline(this.showInboxView);
    }
    if (this.showInboxView) {
      this.inboxViewIndex = index;
    }

    // hide all the drilldown labels
    Object.keys(this.drilldownLabels).forEach((n) => {
      if (this.drilldownLabels[n]) {
        this.drilldownLabels[n].hide();
        this.drilldownLabels[n].destroy();
        delete this.drilldownLabels[n];
        // delete ageData along with drilldown label
        delete this.ageDataByName[n];
      }
    });
    // show the drilldown label of clicked item
    if (this.showInboxView) {
      // Add a delay to ensure the view is ready before making the request
      // The inboxView component needs time to initialize and set up its subscriptions
      const CHART_CLICK_DELAY_MS = 500;
      setTimeout(() => {
        this.requestMessageView(name, color, count);
      }, CHART_CLICK_DELAY_MS);
    }
    // show annotation item
    if (index >= 0 && this.mailboxStatisticsChart && this.mailboxStatisticsChart.annotations
      && this.mailboxStatisticsChart.annotations.length) {
      this.mailboxStatisticsChart.annotations.forEach(elem => {
        if (elem && elem.shapes && elem.shapes.length) {
          elem.graphic.hide();
        }
      });
      if (this.showInboxView) {
        this.mailboxStatisticsChart.annotations[index].graphic.show();
      }
    }
    // update count label color
    // this.updateCountLabelColor(index, this.showInboxView ? '#FCFCFC' : this.labelColor);
    this.updateCloseCallback(index, this.showInboxView);
  }

  updateCloseCallback(index, enabled) {
    if (this.closeCallbackSet !== true && this.chartData && this.chartData.length) {
      for (let i = 0; i < this.chartData.length; i++) {
        let elem = $(".mailbox-statistics-category-label-" + i);
        if (elem && elem.length) {
          elem.click(event => {
            if (this.closeCallbackEnabled) {
              this.closeInplaceView(event, i);
            }
          });
        }
        elem = $(".mailbox-statistics-count-label-" + i);
        if (elem && elem.length) {
          elem.click(event => {
            if (this.closeCallbackEnabled) {
              this.closeInplaceView(event, i);
            }
          });
        }
      }
      this.closeCallbackSet = true;
    }
    this.closeCallbackEnabled = enabled;
  }

  updateCountLabelColor(index, color) {
    if (index >= 0) {
      const elem = $(".mailbox-statistics-count-label-" + index);
      if (elem && elem.length) {
        elem.parent().css('fill', color);
        elem.parent().css('color', color);
      }
      for (let i = 0; i < this.chartData.length; i++) {
        if (i !== index) {
          const elem = $(".mailbox-statistics-count-label-" + i);
          if (elem && elem.length) {
            elem.parent().css('fill', this.labelColor);
            elem.parent().css('color', this.labelColor);
          }
        }
      }
    } else if (this.chartData && this.chartData.length) {
      for (let i = 0; i < this.chartData.length; i++) {
        const elem = $(".mailbox-statistics-count-label-" + i);
        if (elem && elem.length) {
          elem.parent().css('fill', color);
          elem.parent().css('color', color);
        }
      }
    }
  }

  requestMessageView(name: string, color, count) {
    this.inboxService.startViewLoading({ color });
    let filterStr;
    if (name && name.indexOf(this.viewTypeSeparator) !== -1) {
      const vs = name.split(this.viewTypeSeparator);
      name = vs[0];
      filterStr = vs[1];
    }
    sessionStorage.setItem('dashboardInlineTab', name);

    const options = filterStr ? { viewName: name, count, type: 'readBy', value: filterStr === 'read', isDashboardInlineView: true } :
      { viewName: name, count, type: "Mailbox Statistics", isDashboardInlineView: true };
    if (this.prepareInlineViewRequest(options)) {
      // triggering service request and view opening
      this.inboxService.requestView(options);
      this.inboxService.triggerDataChange({ tabName: name.toUpperCase(), dashboardInlineView: true });
    }
    PiwikProUtils.trackJsonDataForEvent(this.userDataService.loggedInUserInfo.pivotProConfigEnabled, this.userDataService.loggedInUserInfo.userId, "Dashboard", "Mailbox Stats click - actions from dashboard-" + name, "Double Click", "Mailbox Stats click - actions from dashboard" + name, 1);
  }

  prepareInlineViewRequest(options) {
    let viewName = options.viewName;
    let myCount = options.count;
    if (viewName === 'Sent') {
      // set tab data before renaming
      viewName = 'Outbox'; // Business asked to rename Outbox to Sent in UI
    } else {
      if (viewName.indexOf('Escalation') > -1) {
        viewName = 'Potential Escalations';
      }
    }

    const requestObj: any = {};
    requestObj.viewName = viewName;
    if (QmaConstant.inboxGridViewType[viewName]) {
      if (QmaConstant.inboxGridViewType[viewName].viewType) {
        requestObj.viewType = QmaConstant.inboxGridViewType[viewName].viewType;
      } else if (QmaConstant.inboxGridViewType[viewName].isChartView) {
        requestObj.isChartView = QmaConstant.inboxGridViewType[viewName].isChartView;
        myCount = undefined;
      }
      if (viewName === 'Assigned To Me') {
        requestObj.assignedToMe = 'Y';
      }
      if (viewName === 'Unassigned') {
        requestObj.unAssignedMessage = 'Y';
      }
      if (options.type && (options.value !== undefined)) { // must check 'undefined' as 'false' would be a valid value
        const filter = { type: options.type, value: options.value, subtype: undefined, subvalue: undefined };
        if (options.subtype && options.subvalue) {
          filter.subtype = options.subtype;
          filter.subvalue = options.subvalue;
        }
        requestObj.filter = filter;
      }
      // always set 'isRequestFromMailBoxStats=true'
      requestObj.isRequestFromMailBoxStats = true;
      this.inboxService.requestObj = requestObj;
      this.inboxService.resetRequest = true;
      // returning true so as to trigger service request
      return true;
    } else {
      // make sure the view exists in local cache before opening inline myview
      let viewIndex = this.inboxService.myViewItems ? this.inboxService.myViewItems.findIndex(item => item && item.name === viewName) : -1;
      if (viewIndex === -1) {
        this.inboxService.stopViewLoading();
      } else {
        // request myview data so as to finalize the request
        requestObj.viewName = viewName;
        requestObj.viewType = -1;
        if (options.type && (options.value !== undefined)) { // must check 'undefined' as 'false' would be a valid value
          const filter = { type: options.type, value: options.value, subtype: undefined, subvalue: undefined };
          if (options.subtype && options.subvalue) {
            filter.subtype = options.subtype;
            filter.subvalue = options.subvalue;
          }
          requestObj.filter = filter;
        }
        this.myViewRequestObject = requestObj;
        this.myViewRequestOptions = options;
        this.myViewService.getUserView(viewName);
      }
      //returning false so as not to trigger service request immediately
      return false;
    }
  }

  /**
   * handling myview inline view request
   */
  initMyViewHandler() {
    this.myViewService.getUserViewSubj().subscribe((userView) => {
      if (!this.myViewRequestObject) {
        return;
      }
      let requestObj = this.myViewRequestObject;
      let searchInType;
      if (userView) {
        // set customized columns to inboxService first
        this.inboxService.customizedColumns = { columns: userView.selectedShowCols };
        if (userView.criteria) {
          const criteria = JSON.parse(userView.criteria);
          if (criteria.$and && criteria.$and.length && criteria.$and[0].viewType) {
            searchInType = criteria.$and[0].viewType;
          }
        }
      }
      //  caching searchInType in request
      if (searchInType) {
        requestObj.myViewSearchInType = searchInType;
      }
      // always set 'isRequestFromMailBoxStats=true'
      requestObj.isRequestFromMailBoxStats = true;
      this.inboxService.requestObj = requestObj;
      this.inboxService.resetRequest = true;
      // triggering service request and view opening
      this.inboxService.requestView(this.myViewRequestOptions);
      this.inboxService.triggerDataChange({ tabName: this.myViewRequestOptions.viewName.toUpperCase(), dashboardInlineView: true });
      // reset request and options
      this.myViewRequestObject = undefined;
      this.myViewRequestOptions = undefined;
    }, (error) => {
      console.log('initMyViewHandler', error);
      this.inboxService.stopViewLoading();
      this.myViewRequestObject = undefined;
      this.myViewRequestOptions = undefined;
    });
  }

  closeInplaceView(event, index) {
    if (index !== -1 && (!this.showInboxView || this.inboxViewIndex !== index)) {
      return;
    }
    // toggle the 'showInboxView'
    this.showInboxView = false;
    this.dashboardService.setDashboardInline(this.showInboxView);
    this.inboxViewIndex = -1;
    // disable callback on labels
    this.closeCallbackEnabled = false;
    // hide all the drilldown labels
    Object.keys(this.drilldownLabels).forEach(name => {
      if (this.drilldownLabels[name]) {
        this.drilldownLabels[name].hide();
        this.drilldownLabels[name].destroy();
        delete this.drilldownLabels[name];
        // delete ageData along with drilldown label
        delete this.ageDataByName[name];
      }
    });
    // hide annotations
    if (this.mailboxStatisticsChart && this.mailboxStatisticsChart.annotations
      && this.mailboxStatisticsChart.annotations.length) {
      this.mailboxStatisticsChart.annotations.forEach(elem => {
        if (elem && elem.shapes && elem.shapes.length) {
          elem.graphic.hide();
        }
      });
    }
    // update count label color
    this.updateCountLabelColor(-1, this.labelColor);
  }

  // handle ESC in case of full screen
  @HostListener('document:keydown.esc', ['$event'])
  onKeydown(event) {
    event.stopPropagation();
    event.preventDefault();
    if (this.fullScreen && event && event.code === 'Escape') {
      this.exitFullScreen(this.mailboxStatisticsChart);
    }
    return false;
  }

  enterFullScreen(chart: any) {
    const elem = $('#mailbox-statistics-chart-box');
    if (elem && elem.length) {
      elem.toggleClass('dashboardModal');
    }
    if (this.closeCallbackEnabled) {
      this.closeInplaceView(event, -1);
    }
    this.fullScreen = true;
    if (chart.exportContextMenu && chart.exportContextMenu.childNodes) {
      chart.exportContextMenu.childNodes.forEach(node => {
        if (node && node.childNodes) {
          node.childNodes.forEach(n => {
            if (n && n.innerText === 'Maximize') {
              n.style.display = 'none';
            }
          });
        }
      });
    }
    if (this.fadingDialogComponent) {
      this.fadingDialogComponent.show($('#mailbox-statistics-box')[0]);
    }
  }

  exitFullScreen(chart: any) {
    if (!chart) {
      return;
    }
    const elem = $('#mailbox-statistics-chart-box');
    if (elem && elem.length) {
      elem.toggleClass('dashboardModal');
    }
    this.fullScreen = false;
    if (this.fadingDialogComponent) {
      this.fadingDialogComponent.hide($('#mailbox-statistics-box')[0]);
    }
    if (chart.exportContextMenu && chart.exportContextMenu.childNodes) {
      chart.exportContextMenu.childNodes.forEach(node => {
        if (node && node.childNodes) {
          node.childNodes.forEach(n => {
            if (n && n.innerText === 'Maximize') {
              n.style.display = '';
            }
          });
        }
      });
    }
    chart.reflow();
  }

  categoryLabelBias(label: string): number {
    if (!label || !label.length) {
      return 0;
    }
    return (14 - label.length) * 3.3 - 28;
  }
  downloadCustomCsv() {
    let csv = 'Category, Total Inquiry Count, UnRead Inquiry Count, % Change with respect to Previous Day\n';
    this.data.mailBoxStat.forEach(element => {
      csv += element.category + ',' + element.count + ',' + (element.unReadCount !== undefined ? element.unReadCount : 0)
        + "," + element.percentWrtPrevDay + '\n';
    });
    const hiddenElement = document.createElement('a');
    hiddenElement.href = 'data:text/csv;charset=utf-8,' + csv;
    hiddenElement.target = '_blank';
    hiddenElement.download = 'Mail_Box_Statistics.csv';
    hiddenElement.click();
  }

  getUnReadCount(e) {
    if (!e || !e.unReadCount) {
      return 0;
    } else {
      return parseInt(e.unReadCount, 10);
    }
  }

  updateTooltip(tooltip, point, t) {
    const result = [];
    const p0index = point.index;
    const s0index = point.series.index;
    const emptyData = point.series.chart.options.series[s0index].emptyData;
    const total = emptyData ? '0' : '' + (parseInt(point.series.data[0].y) + parseInt(point.series.data[1].y)).toLocaleString();
    result.push('<table style="border-collapse:collapse;">');
    result.push('<tr><td style="bording-spacing:2px;padding:2px;padding-bottom:5px"><span style="color:' + point.series.data[p0index].color + ';">● </span><b>' + point.name +
      ': ' + (emptyData ? 0 : point.series.data[p0index].y.toLocaleString()) + '</b></td></tr>' +
      '<tr><td style="bording-spacing:2px;"><span style="font-size:11px;">' + '<b>&nbsp;&nbsp;&nbsp;( Total:  ' + total + ' )</b></span></td></tr>');
    result.push('</table>');
    return result;
  }

  onCarouselClick(idx: number) {
    this.selectedIndex = idx;
    this.chartWidth = undefined;
    this.chartHeight = undefined;
    this.redrawWidgets(this.mailboxStatisticsChart);
  }

  onSwipe(str: string) {
    if (str === 'left') {
      if (this.selectedIndex < (this.mailboxStats.length - 1)) {
        this.selectedIndex++;
        this.onCarouselClick(this.selectedIndex);
      }
    }
    else {
      if (this.selectedIndex > 0) {
        this.selectedIndex--;
        this.onCarouselClick(this.selectedIndex);
      }
    }

  }

  resetInlineView() {
    if (this.fullScreen) {
      return;
    }
    const index = -1;
    this.showInboxView = false;
    this.dashboardService.setDashboardInline(this.showInboxView);
    this.inboxViewIndex = index;

    // hide all the drilldown labels
    Object.keys(this.drilldownLabels).forEach((n) => {
      if (this.drilldownLabels[n]) {
        this.drilldownLabels[n].hide();
        this.drilldownLabels[n].destroy();
        delete this.drilldownLabels[n];
        // C153176-4700: delete ageData along with drilldown label
        delete this.ageDataByName[n];
      }
    });

    // show annotation item
    if (index >= 0 && this.mailboxStatisticsChart && this.mailboxStatisticsChart.annotations
      && this.mailboxStatisticsChart.annotations.length) {
      this.mailboxStatisticsChart.annotations.forEach(elem => {
        if (elem && elem.shapes && elem.shapes.length) {
          elem.graphic.hide();
        }
      });
    }
    // update count label color
    this.updateCountLabelColor(index, this.showInboxView ? '#FCFCFC' : this.labelColor);
    this.updateCloseCallback(index, this.showInboxView);
  }

  getPercentage(value) {
    if (!value) {
      return 0;
    }
    // C153176-4577: support large percentage value
    let p;
    if (typeof value === 'string') {
      p = parseFloat(value.replace(/,/g, ''))
    } else if (typeof value === 'number') {
      p = value;
    }
    if (p >= 1000) {
      return ((p / 1000).toFixed(2) + "k");
    } else {
      return p.toFixed(2);
    }
  }

  getDonutColor(category) {
    let color = "";
    const chartName = category ? category.toUpperCase() : category;
    switch (chartName) {
      case 'SENT': {
        color = '#00B0B9';
        break;
      }
      case 'RESOLVED': {
        color = '#bb86fc';
        break;
      }
      default: {
        color = this.defaultColor;
        break;
      }
    }
    return color;
  }
  closeInboxView()  {
    this.handleDoubleClick(this.dataToCloseInbox.index, this.dataToCloseInbox.name, this.dataToCloseInbox.color, this.dataToCloseInbox.count);
  }
}